import { Product } from '../../../models/Product';
import './ProductMiniatureList.less';
import ProductMiniature, { ProductMiniatureProps } from './ProductMiniature';

export type ProductMiniatureListProps = {
    className?: string;
    maxProductsToShow?: number;
    products: Product[];
    size: ProductMiniatureProps['size'];
    misaligned?: boolean;
};

const ProductMiniatureList = ({
    className = '',
    maxProductsToShow = 3,
    products,
    misaligned,
    size
}: ProductMiniatureListProps) => {
    const productsWithImage = products
        .filter(p => p.images.length > 0)
        .slice(0, maxProductsToShow);
    const hiddenProducts = products.length - productsWithImage.length;
    return (
        <div
            className={`bri-ProductMiniatureList bri-ProductMiniatureList-size-${size} ${misaligned ? 'bri-misaligned' : ''} ${className} ${
                productsWithImage.length === 1
                    ? 'bri-ProductMiniatureList-single'
                    : ''
            }`}
        >
            {productsWithImage.map((p, index) => (
                <ProductMiniature
                    size={size}
                    aspectRatio="1"
                    border
                    animationDelay={index * 200}
                    product={p}
                />
            ))}
            {hiddenProducts > 0 && (
                <ProductMiniature
                    size={size}
                    aspectRatio="1"
                    border
                    animationDelay={productsWithImage.length * 200}
                    iconId="plus"
                />
            )}
        </div>
    );
};

export default ProductMiniatureList;
